import {createGlobalStyle} from 'styled-components'

export const GlobalStyles = createGlobalStyle`
        body{
            background: ${({theme})=> theme.body};
            color: ${({theme})=> theme.text};
            transition: all 0.3s linear;
        }
`